import PageShell from "@/components/PageShell";

export default function PrivacyPolicy() {
  return (
    <PageShell testid="privacy-policy-page" eyebrow="Legal" title="Privacy Policy." updated="26 September 2026">
      <p>
        French Pie ("we", "us", "our") operates www.frenchpie.co.in. This Privacy Policy explains what information we
        collect, how we use it, and the rights you have. It applies to visitors in India and is framed in line with
        the Digital Personal Data Protection Act, 2023 and applicable Indian law.
      </p>

      <h2>1. Information we collect</h2>
      <ul>
        <li>
          <strong>Order and enquiry details you give us:</strong> name, phone number, email address, pickup slot,
          order items and any note you choose to add.
        </li>
        <li>
          <strong>Payment information:</strong> online payments are processed by Razorpay. We never see or store your
          card number, UPI PIN or CVV — we receive only a payment confirmation, payment ID and the amount.
        </li>
        <li>
          <strong>Technical data:</strong> basic server logs such as IP address, browser type and pages visited, used
          for security and site improvement.
        </li>
      </ul>

      <h2>2. How we use information</h2>
      <ul>
        <li>To prepare, confirm and hand over your pickup order, and to contact you about it.</li>
        <li>To reply to franchise, catering and general enquiries.</li>
        <li>To send you service messages about your order (confirmations, pickup updates).</li>
        <li>To keep the website secure, prevent fraud and comply with legal obligations.</li>
        <li>We do not sell your data. We do not send marketing messages without your consent.</li>
      </ul>

      <h2>3. Cookies</h2>
      <p>
        Our website uses only essential cookies and equivalent local storage needed for the site to function (for
        example, remembering your basket while you browse). We do not use advertising or third-party tracking
        cookies. You can clear or block cookies in your browser settings; the site will continue to work.
      </p>

      <h2>4. Third-party disclosure</h2>
      <ul>
        <li>
          <strong>Razorpay</strong> — processes online payments as our payment service provider, under its own
          privacy policy.
        </li>
        <li>
          <strong>Email delivery provider</strong> — delivers your order confirmation to us (and to you, if you leave
          an email).
        </li>
        <li>
          <strong>Law enforcement / authorities</strong> — only where required by applicable Indian law.
        </li>
      </ul>
      <p>We do not otherwise share, rent or trade your personal information with anyone.</p>

      <h2>5. How we protect information</h2>
      <p>
        Data travels over encrypted connections (HTTPS). Orders are stored in access-controlled databases, and
        payment credentials are handled entirely by Razorpay (PCI-DSS compliant). We keep order records only as long
        as needed for business, tax and legal purposes.
      </p>

      <h2>6. Your rights</h2>
      <ul>
        <li>Ask what personal data we hold about you and get a copy.</li>
        <li>Ask us to correct or erase your personal data.</li>
        <li>Withdraw consent or object to processing, and ask us not to contact you.</li>
        <li>Nominate another person to exercise these rights if you are unable to.</li>
      </ul>
      <p>
        To exercise any right, email <strong>bemina@frenchpie.co.in</strong>. We respond within 7 working days.
      </p>

      <h2>7. Notification of changes</h2>
      <p>
        If we change this policy, we will post the updated version here with a new "Last updated" date. For
        significant changes we will also announce them on the website's home page.
      </p>

      <h2>8. Contact &amp; grievance officer</h2>
      <p>
        French Pie (Sahil &amp; Co), Havells Galaxy, Sector 3, Shamasabad, Bemina, Srinagar, Jammu &amp; Kashmir
        190018 · bemina@frenchpie.co.in · +91 95967 66336.
      </p>
    </PageShell>
  );
}
